export default __webpack_public_path__ + "static/media/gallery_03.7a7517c9.jpg";